import cn from 'classnames'
import React from 'react'
import { ArrowBigUp, Sprout } from 'lucide-react'
import { isDefaultUpvalueEmoji, isSeedEmoji } from './upvalueEmoji'

type UpvalueGlyphProps = {
    emoji?: string | null
    className?: string
    size?: number
}

export default function UpvalueGlyph({ emoji, className, size = 16 }: UpvalueGlyphProps) {
    if (isDefaultUpvalueEmoji(emoji)) {
        return <ArrowBigUp className={cn(className)} size={size} strokeWidth={2.5} aria-hidden />
    }

    if (isSeedEmoji(emoji)) {
        return <Sprout className={cn(className)} size={size} strokeWidth={2.2} aria-hidden />
    }

    return (
        <span className={className} style={{ fontSize: size, lineHeight: 1 }}>
            {emoji}
        </span>
    )
}
